import React, { useState } from "react";
import "../LoginComponent/LoginComponent.css";
import projectlogo from "../../Assets/projectlogo.jpg";
import GoogleLoginCustom from "../GoogleLogin/GoogleLogin";
import { Link, useNavigate } from "react-router-dom";
import { FaLock } from "react-icons/fa";
import { LuEyeOff, LuEye } from "react-icons/lu";
import { toast } from "react-toastify";
import { FaRegUserCircle } from "react-icons/fa";
import {
  APIUrl,
  APIUrlToken,
  SetlocalStorage,
  storeIsAdmin,
} from "../../Utils/Utils";
import axios from "axios";
import Loader from "../Loader/Loader";

const LoginComponent = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const toggleShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };
  const validateFields = () => {
    if (!username.trim()) {
      toast.error("Please enter a valid Email");
      return false;
    }
    if (!password.trim()) {
      toast.error("Please enter Password");
      return false;
    }
    return true;
  };
  const handleDashboardClick = async () => {
    if (!validateFields()) return;
    const formData = new FormData();
    formData.append("username", username);
    formData.append("password", password);

    setLoading(true);
    const url = `${APIUrl()}/v1/local/auth/login`;
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
        "X-API-Key": APIUrlToken(),
      },
      data: formData,
      url: url,
    };

    try {
      const response = await axios(options);
      SetlocalStorage("isAdmin", response.data?.is_admin);
      SetlocalStorage("nilToken", response.data);
      toast.success("User Logged in successfully!");
      navigate("/dashboard/start-your-brand-partnership/1/hawaii");
    } catch (error) {
      toast.error(
        error?.response?.data?.detail ||
          "Error creating user. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="login-wrapper">
        {/* <a href="https://nildonate.com/v1/google/auth/login">login button</a> */}
        <div className="login-container">
          <div className="login-box">
            <div className="projectlogo-container">
              <img src={projectlogo} alt="Project Logo" className="logoimage" />
            </div>
            <div className="social-login-container">
              <GoogleLoginCustom />
            </div>

            <div className="profile-card-login">
              <div className="input-section-changepass">
                <div className="input-group-changepass">
                  <div className="input-icon-changepass">
                    <FaRegUserCircle />
                  </div>
                  <input
                    type="text"
                    className="form-control-changepass"
                    id="username"
                    name="username"
                    placeholder="Email"
                    value={username}
                    onChange={handleUsernameChange}
                  />
                </div>
              </div>

              <div className="input-section-changepass">
                <div className="input-group-changepass">
                  <div className="input-icon-changepass">
                    <FaLock />
                  </div>
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control-changepass"
                    id="password"
                    name="password"
                    placeholder="Password"
                    value={password}
                    onChange={handlePasswordChange}
                  />
                  {showPassword ? (
                    <LuEye className="eye-svg" onClick={toggleShowPassword} />
                  ) : (
                    <LuEyeOff
                      className="eye-svg"
                      onClick={toggleShowPassword}
                    />
                  )}
                </div>
              </div>
            </div>

            <div className="submit-buttons">
              <button
                type="submit"
                className="submit-btn"
                onClick={handleDashboardClick}
              >
                Login
              </button>
            </div>
            <div className="p-2">
              <div className="not-registered-login">
                Not Registered? <Link to="/CreateUser">Register here</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginComponent;
